var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"default-opacity-transition","mode":"out-in"}},[(_vm.loading)?_c('s-loader'):_c('router-view',{attrs:{"asset":_vm.currentAsset,"asset-type":_vm.currentAssetType,"sensor":_vm.sensor}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }